import { useState } from 'react';
import { buildJobPostingSchema } from '../../../utils/jobPostingSchema';

const JSON_LD_ID = 'job-posting-jsonld';

// Renders JobPosting structured data (JSON-LD) for a single job — but ONLY
// if the page didn't already ship one from the prerender step. Cold-loaded
// pages (Googlebot, hard refresh, shared links) get the prerendered
// build/jobs/{id}/index.html file, which already has this tag baked in with
// id="job-posting-jsonld". Normal in-app navigation (clicking a job card)
// never hits that file — it's pure client-side routing — so this component
// covers that case by injecting the tag itself, but only when needed.
//
// Uses React 19's native support for rendering <script> as JSX. Note this
// does NOT get hoisted into <head> the way <title>/<meta>/<link> do — it
// renders wherever this component sits in the tree. That's fine: Google
// reads structured data from anywhere in the page, not just <head>.
const JobPostingJsonLd = ({ job }) => {
  const [alreadyPresent] = useState(() => typeof document !== 'undefined' && !!document.getElementById(JSON_LD_ID));

  if (alreadyPresent) return null;

  const schema = buildJobPostingSchema(job);
  if (!schema) return null;

  return (
    <script type="application/ld+json" id={JSON_LD_ID}>
      {JSON.stringify(schema)}
    </script>
  );
};

export default JobPostingJsonLd;
